import { hasPermission } from "./permissions";

export const getUserManagementPermissions = (permissions) => {
  return {
    canView: hasPermission(permissions, "User Management", "view"),
    canEdit: hasPermission(permissions, "User Management", "edit"),
    canCreate: hasPermission(permissions, "User Management", "write"),
  };
};

export const getRbscManagementPermissions = (permissions) => {
    if (!permissions || permissions.length === 0) {
    return { canView: true, canEdit: true, canCreate: true ,canDelete :true };
  }
  return {
    canView: hasPermission(permissions, "RBAC Management", "view"),
  canEdit: hasPermission(permissions, "RBAC Management", "edit"),
  canCreate: hasPermission(permissions, "RBAC Management", "write"),
  canDelete: hasPermission(permissions, "RBAC Management", "delete"),
  };
};

export const getServiceManagementPermissions = (permissions) => {
  return {
  canCreate: hasPermission(permissions, "Service Settings", "write"),
  canDelete: hasPermission(permissions, "Service Settings", "delete"),
  };
};

export const getApprovalManagementPermissions = (permissions) => {
  return {
  canEdit: hasPermission(permissions, "Approval Dashboard", "edit"),
  };
};

